(function ($) {
  $(window).on('load', function () {
      var windowWidth = $(window).width();
      var windowSm = 1024; // スマホに切り替わる横幅
      if (windowWidth <= windowSm) {
        var headerHeight = 80; // スマホのヘッダー等の高さ分の数値を入れる
        $('#navOpen').append('<span/>').on('click',function () {
          // $(this).toggleClass('open');
          $('#navGlobal .navGroup').slideToggle('slow');
        });
  
        $('#navGlobal [href^="#"]').on('click',function(){
          smooth(this);
          $('#navOpen').removeClass('open');
          $('#navGlobal .navGroup').slideUp('slow');
          return false;
        });
      } else {
        var headerHeight = 110;
        var headNav = $("#pageHeader");
        //scrollだけだと読み込み時困るのでloadも追加
        $(window).on('load scroll', function () {
          //現在の位置が500px以上かつ、クラスfixedが付与されていない時
          if ($(this).scrollTop() > 200 && headNav.hasClass('fixed') == false) {
            //headerの高さ分上に設定
            headNav.css({
              "top": '-135px'
            });
            //クラスfixedを付与
            headNav.addClass('fixed');
            //位置を0に設定し、アニメーションのスピードを指定
            headNav.animate({
              "top": 0
            }, 500);
          }
          //現在の位置が300px以下かつ、クラスfixedが付与されている時にfixedを外す
          else if ($(this).scrollTop() < 135 && headNav.hasClass('fixed') == true) {
            headNav.removeClass('fixed');
          }
        });
  
        var url = $(location).attr('href');
        if (url.indexOf("?id=") != -1) {
          var speed = 1000;
          var id = url.split("?id=");
          var $target = $('#' + id[id.length - 1]);
          if ($target.length) {
            var pos = $target.offset().top - headerHeight;
            $("html, body").animate({
              scrollTop: pos
            }, speed, "swing");
          }
        }
      }
     });
    
    /*smooth scroll*/
    $('[href^="#"]:not(.js-modal)').click(function () {
      smooth(this);
      return false;
    });
    $('.pageTop a').click(function () {
      animateoffset(0);
      return false;
    });
    /*smooth scroll*/
  
    var topBtn = $('.pageTop');
    topBtn.hide();
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        topBtn.fadeIn();
      } else {
        topBtn.fadeOut();
      }
    });
    //スクロールしてトップ
    topBtn.click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 500);
      return false;
    });
      /*function:smooth scroll*/
  function smooth(target){
      var windowWidth = $(window).width();
    var windowSm = 769; // スマホに切り替わる横幅
      if (windowWidth <= windowSm) {
       var headerHeight = 60; // スマホのヘッダー等の高さ分の数値を入れる
       } else {
       var headerHeight = 80;
      }
    var href = jQuery(target).attr('href');
    var offset = headerHeight;
    //var offset = 0;
    var top = jQuery(href).offset().top - offset;
    animateoffset(top);
  }
  function animateoffset(top){
    jQuery('html,body').animate({scrollTop:top},1000);
  }
  /*function:smooth scroll*/
  
  $(window).scroll(function () {
    $('.fadein').each(function () {
      var elemPos = $(this).offset().top,
        scroll = $(window).scrollTop(),
        windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight + 100) {
        $(this).addClass('scrollin');
      }
    });
  });


  $('.fadeup').addClass('fade_in_up');

  

  /* Custom Headerの挙動 ここから */

  /*slide menu*/
  $('#navOpen').append('<span/>').on('click',function () {
    // $(this).toggleClass('open');
    $('#navGlobal').toggleClass('open');
  });
  
  $('#navGlobal [href^="#"]').on('click',function(){
    smooth(this);
    $('#navOpen').removeClass('open');
    $('#navGlobal').removeClass('open');
    return false;
  });
  /*slide menu*/

  $('[href^="#"]:not(.js-modal)').click(function () {
    smooth(this);
    return false;
  });

  $('.pageTop a').click(function () {
    animateoffset(0);
    return false;
  });

    /*function:smooth scroll*/
  function smooth(target) {
    var windowWidth = $(window).width();
    var windowSm = 787; // スマホに切り替わる横幅
    if (windowWidth <= windowSm) {
      var headerHeight = 40; // スマホのヘッダー等の高さ分の数値を入れる
    } else {
      var headerHeight = 80; // PC のヘッダー等の高さ分の数値を入れる
    }
    var href = jQuery(target).attr('href');
    var offset = headerHeight;
    //var offset = 0;
    var top = jQuery(href).offset().top - offset;
    animateoffset(top);
  }

  function animateoffset(top) {
    jQuery('html,body').animate({
      scrollTop: top
    }, 1000);
  }
  /*function:smooth scroll*/

  var topBtn = $('.pageTop');
  topBtn.hide();
  //スクロールが100に達したらボタン表示
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });
  //スクロールしてトップ
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    return false;
  });


  $(window).scroll(function (){
    $('.fadein').each(function(){
        var elemPos = $(this).offset().top,
            scroll = $(window).scrollTop(),
            windowHeight = $(window).height();
          if (scroll > elemPos - windowHeight + 100){
              $(this).addClass('scrollin');
            }
        });
    });

  $('.fadeup').addClass('fade_in_up');

  // アコーディオンを全て取得
  const accordions = document.querySelectorAll(".js-accordion");
  // 取得したアコーディオンをArrayに変換(IE対策)
  const accordionsArr = Array.prototype.slice.call(accordions);

  accordionsArr.forEach((accordion) => {
  // Triggerを全て取得
  const accordionTriggers = accordion.querySelectorAll(".js-accordion-trigger");
  // TriggerをArrayに変換(IE対策)
  const accordionTriggersArr = Array.prototype.slice.call(accordionTriggers);

  accordionTriggersArr.forEach((trigger) => {
    // Triggerにクリックイベントを付与
    trigger.addEventListener("click", () => {
      // '.is-active'クラスを付与or削除
      trigger.classList.toggle("is-active");
      // 開閉させる要素を取得
      const content = trigger.querySelector(".accordion__content");
      // 要素を展開or閉じる
      slideToggle(content);
    });
  });
  });
  
  /* Custom Headerの挙動 ここまで */


}
)(jQuery);
  